<template>
  <div style="padding: 20px 15px">
    <div style="text-align: center; margin-bottom: 20px">
      <h3>合意I 隐私政策</h3>
      <p>版本生效日期：2025年10月29日</p>
      <p>发布主体：无锡风睐科技有限公司（以下简称“本公司”“我们”或“合意I”）</p>
    </div>
    <h4 style="margin-bottom: 20px; font-weight: bold">第一条 总则</h4>
    <p>
      1.
      无锡风睐科技有限公司高度重视用户的隐私与个人信息保护。本隐私政策旨在说明我们如何收集、使用、保存、共享及保护您的个人信息。
    </p>
    <p>
      2.
      请您在使用本应用前仔细阅读本政策。使用本应用即表示您已充分理解并同意本政策的全部内容。
    </p>
    <h4 style="margin-bottom: 20px; font-weight: bold">
      第二条 我们收集的信息类型
    </h4>
    <p>在您使用本应用过程中，我们可能收集以下信息：</p>
    <p>1.账户信息：包括手机号、登录凭证。</p>
    <p>2.身份验证信息：包括面部图像、活体检测视频数据。</p>
    <p>3.位置信息：用于记录协议签署地点。</p>
    <p>4.设备信息：包括设备型号、系统版本、唯一设备标识符。</p>
    <p>5.协议内容信息：包括双方填写的文本、时间、签署记录。</p>
    <p>
      6.支付信息：当您使用电子存证等付费服务时，我们会收集交易订单号、支付金额、支付渠道等信息。
    </p>
    <h4 style="margin-bottom: 20px; font-weight: bold">
      第三条 信息的使用目的
    </h4>
    <p>我们收集的信息将用于以下目的：</p>
    <p>1.注册与登录验证；</p>
    <p>2.生成与存储电子协议；</p>
    <p>3.验证签署者身份真实性；</p>
    <p>4.提供电子存证及司法导出服务；</p>
    <p>5.提升产品安全性与用户体验；</p>
    <p>6.履行法律法规规定的义务。</p>
    <h4 style="margin-bottom: 20px; font-weight: bold">
      第四条 敏感个人信息处理
    </h4>
    <p>
      1.
      活体检测涉及面部识别数据，属于敏感个人信息，我们仅在您明确授权后进行采集与处理。
    </p>
    <p>2. 定位信息仅用于协议签署记录，不会用于持续追踪。</p>
    <p>3. 相关数据将采用加密存储，并仅限于协议验证和存证使用。</p>
    <h4 style="margin-bottom: 20px; font-weight: bold">
      第五条 信息的共享、转让与公开披露
    </h4>
    <p>1. 我们不会向任何第三方出售或出租您的个人信息。</p>
    <p>2. 在以下情形下，我们可能共享您的信息：</p>
    <p>(1)为提供电子存证，由合作的司法公信机构处理；</p>
    <p>(2)为完成支付，由支付机构处理交易信息；</p>
    <p>(3)根据法律法规、司法机关或行政机关的合法要求。</p>
    <p>3. 除上述情形外，未经您同意，我们不会公开披露您的个人信息。</p>
    <h4 style="margin-bottom: 20px; font-weight: bold">
      第六条 信息的存储与保护
    </h4>
    <p>1. 所有用户数据将存储在中华人民共和国境内的服务器上。</p>
    <p>
      2.
      我们采用行业标准的安全防护措施，包括加密存储、访问控制、日志审计等，防止数据泄露、篡改或丢失。
    </p>
    <p>3. 用户有权随时注销账户并要求删除个人信息，法律另有规定的除外。</p>
    <h4 style="margin-bottom: 20px; font-weight: bold">第七条 用户权利</h4>
    <p>用户在使用本应用期间享有以下权利：</p>
    <p>1.查询、更正、删除个人信息；</p>
    <p>2.撤回授权；</p>
    <p>3.注销账户；</p>
    <p>4.获取存证副本或导出记录；</p>
    <p>5.投诉举报。</p>
    <h4 style="margin-bottom: 20px; font-weight: bold">第八条 政策更新</h4>
    <p>
      我们可能因法律变化或业务调整不时修改本政策。更新后的政策将在应用内显著位置公示，若您继续使用本应用，即视为接受修订内容。
    </p>
    <h4 style="margin-bottom: 20px; font-weight: bold">第九条 争议解决</h4>
    <p>
      本协议签订地为中华人民共和国江苏省无锡市梁溪区。因本政策产生的争议，适用中华人民共和国法律，并由本协议签订地有管辖权的人民法院管辖。
    </p>
    <h4 style="margin-bottom: 20px; font-weight: bold">第十条 联系我们</h4>
    <p>若您对本政策有任何疑问、投诉或建议，可通过以下方式与我们联系：</p>
    <p>公司名称：无锡风睐科技有限公司</p>
    <p>电子邮箱：18674043327@163.com</p>
    <p>公司地址：江苏省无锡市梁溪区中山路333-12G</p>
  </div>
</template>
<script setup></script>
<style lang="scss" scoped>
p {
  font-size: 14px;
}
</style>
